import React from 'react';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { Grid, GridItem, Container, Stack, Divider, Section } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { Button } from '@fiverr-private/button';
import { ElementType } from '@fiverr-private/bianka_js';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import pathfinder from '@fiverr-private/pathfinder';
import SafeComponent from '../../shared/SafeComponent';
import { getImpressionEnrichment, sendBigQueryEvent, sendMixPanelEvent } from '../../utils/biEvents';
import {
    BQ_CLICKED_USPSS_BUTTON,
    BQ_HOVERED_USP,
    BQ_IMP_USPSS_IS_SHOWN,
} from '../../utils/biEvents/events/bigQueryEvents';
import { MP_USPSS_CLICKED } from '../../utils/biEvents/events/mixPanelEvents';
import { reportClick } from '../../utils/biEvents/events/biankaEvents';
import fingertipsData from './config';

const Freelancers = () => {
    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_IMP_USPSS_IS_SHOWN }));
    const pathToJoin = pathfinder('join', undefined, { query: { source: 'lohp_uspss' } });

    const onHover = () => {
        sendBigQueryEvent({ eventName: BQ_HOVERED_USP });
    };

    const onSignUpButtonClick = async (event) => {
        event.preventDefault();

        sendMixPanelEvent({ eventName: MP_USPSS_CLICKED });
        reportClick({
            eventName: BQ_CLICKED_USPSS_BUTTON,
            elementName: 'uspss_button',
            elementType: ElementType.BUTTON,
        });
        await triggerSignUp({
            modalOptions: {
                triggerType: 'user_trigger',
                triggerId: 'lohp_uspss',
            },
        });
    };

    return (
        <Section paddingTop={{ default: '8', md: '10' }} paddingBottom={{ default: '16', md: '20' }}>
            <Container onMouseEnter={onHover} data-test-id="fingertips-container" ref={ref}>
                <Stack justifyContent="spaceBetween" alignItems="center" marginBottom={{ default: '10', md: '0' }}>
                    <Typography
                        size={{ default: 'h_xl', md: 'h_xxl' }}
                        as="h2"
                        letterSpacing="-0.03em"
                        fontWeight="normal"
                    >
                        <I18n k="logged_out_homepage.freelancers.title" />
                    </Typography>

                    <Button
                        href={pathToJoin}
                        onClick={onSignUpButtonClick}
                        className="btn-signup"
                        hidden={{ default: true, md: false }}
                    >
                        <I18n k="logged_out_homepage.freelancers.cta" />
                    </Button>
                </Stack>

                <Container hidden={{ default: true, md: false }} marginTop="6" marginBottom="16" display="flex">
                    <Divider />
                </Container>

                <Grid
                    as="ul"
                    templateColumns={{ default: '100%', md: '25%_25%_25%_25%' }}
                    gap={{ default: '10', md: '8' }}
                    marginBottom={{ default: '10', md: '0' }}
                >
                    {fingertipsData.map(({ id, title, image }) => (
                        <GridItem
                            display="flex"
                            key={id}
                            direction={{ default: 'row', md: 'column' }}
                            alignItems={{ default: 'center', md: 'flexStart' }}
                            gap={{ default: '4', md: '3' }}
                        >
                            <Image
                                src={image}
                                alt={translate<string>(title)}
                                width={{ default: '52px', md: '64px' }}
                                height={{ default: '52px', md: '64px' }}
                            />
                            <Typography color="grey_1100" maxWidth="232px">
                                {translate<string>(title)}
                            </Typography>
                        </GridItem>
                    ))}
                </Grid>
                <Stack justifyContent={{ default: 'flexStart', md: 'center' }} hidden={{ default: false, md: true }}>
                    <Button href={pathToJoin} onClick={onSignUpButtonClick} className="btn-signup">
                        <I18n k="logged_out_homepage.freelancers.cta" />
                    </Button>
                </Stack>
            </Container>
        </Section>
    );
};

export { Freelancers };
export default SafeComponent(Freelancers);
